import Header from "@/components/Header";
import { Outlet } from "react-router-dom";
import AppSidebar from "@/components/AppSidebar";
import { mainSidebarMenu } from "@/utils/constants/sidebar-menu";
import { appLogoSmIconNew } from "@/assets";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { MessageSquare } from "lucide-react";
import LayoutStatusPanel from "@/layouts/LayoutStatusPanel";
import { defaultProjectId, projectDefinitions } from "@/features/schedule/schedule-data";
import { useLocation } from "react-router-dom";

const MainLayout = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [isRightPanelOpen, setIsRightPanelOpen] = useState(false);
  const [isStatusPanelCollapsed, setIsStatusPanelCollapsed] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(defaultProjectId);
  const showScheduleProjects = location.pathname === "/schedule";

  return (
    <div className="flex min-h-screen w-full bg-[#EEF1F4]">
      <div id="main-layout-inner" className="relative flex min-h-screen w-full flex-col">
        <Header
          mobileRightPanelButton={
            isMobile ? (
              <Button
                type="button"
                size="icon"
                variant="ghost"
                className="h-8 w-8 rounded-full border border-white/30 bg-white/10 text-white hover:bg-white/20"
                onClick={() => setIsRightPanelOpen(true)}
                aria-label="Open status panel"
              >
                <MessageSquare className="h-4 w-4" />
              </Button>
            ) : null
          }
        />

        <div className="flex min-h-0 flex-1 gap-0 p-0">
          <AppSidebar
            icon={appLogoSmIconNew}
            menu={mainSidebarMenu}
          />
          <div className="flex min-h-0 min-w-0 flex-1 gap-3 px-2 py-2">
            <div className="flex min-h-0 min-w-0 flex-1 rounded-[8px] border border-[#D4D8DC] bg-white p-1">
              <div
                className="min-h-0 w-full overflow-y-auto rounded-[6px] p-4"
                id="main-content-container"
              >
                <Outlet context={{ selectedProjectId, setSelectedProjectId }} />
                {/* <AnimatedOutletVariants variant="fade" duration={0.28} /> */}
              </div>
            </div>

            {!isMobile && (
              <aside
                className={`hidden min-h-0 shrink-0 transition-[width] duration-300 md:block ${
                  isStatusPanelCollapsed ? "w-[60px]" : "w-[260px]"
                }`}
              >
                <LayoutStatusPanel
                  collapsed={isStatusPanelCollapsed}
                  onToggleCollapse={() => setIsStatusPanelCollapsed((current) => !current)}
                  projects={projectDefinitions}
                  selectedProjectId={selectedProjectId}
                  onSelectProject={setSelectedProjectId}
                  showProjects={showScheduleProjects}
                />
              </aside>
            )}
          </div>
        </div>
      </div>

      {isMobile && (
        <Sheet open={isRightPanelOpen} onOpenChange={setIsRightPanelOpen}>
          <SheetContent side="right" className="w-[280px] border-l border-[#C9D3DA] bg-[#EEF1F4] p-3">
            <SheetHeader className="sr-only">
              <SheetTitle>Status panel</SheetTitle>
              <SheetDescription>Shows recent logs and alerts.</SheetDescription>
            </SheetHeader>
            <LayoutStatusPanel
              projects={projectDefinitions}
              selectedProjectId={selectedProjectId}
              onSelectProject={setSelectedProjectId}
              showProjects={showScheduleProjects}
            />
          </SheetContent>
        </Sheet>
      )}
    </div>
  );
};

export default MainLayout;
